(function() {
    'use strict';

    angular
        .module('adelementAdminApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
